<template>
  <div>
    <slot />
    <div v-for="category in getCategories" :key="`category-${category.id}`">
      <ci-category-item
        :category="category"
        :display-children="displayChildren"
        :parent-selectable="parentSelectable"
        :single-select="singleSelect"
        :selected-categories="selectedCategories"
        @category-item:selected="onCategorySelected"
        small
        selectable />
    </div>
  </div>
</template>

<script>
import CategoryItem from '@/components/categories/CategoryItem.vue';
import CategoryService from '@/services/CategoryService';

export default {
  name: 'CategorySelector',

  components: {
    'ci-category-item': CategoryItem,
  },

  props: {
    availableCategories: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    displayChildren: {
      type: Boolean,
      required: false,
      default: false,
    },

    singleSelect: {
      type: Boolean,
      required: false,
      default: false,
    },

    parentSelectable: {
      type: Boolean,
      required: false,
      default: false,
    },

    preSelectedCategories: {
      type: Array,
      required: false,
    },
  },

  data() {
    return {
      categories: [],
      selectedCategories: [],
    };
  },

  created() {
    CategoryService.findParents()
      .then((categories) => {
        this.categories = categories;
      });

    if (this.preSelectedCategories && this.preSelectedCategories.length) {
      this.selectedCategories = this.preSelectedCategories;
    }
  },

  watch: {
    preSelectedCategories(newVal) {
      this.selectedCategories = newVal;
    },
  },

  methods: {
    deselectChildren(categories) {
      for (let i = 0; i < categories.length; i += 1) {
        const category = categories[i];
        const categoryIndex = this.selectedCategories.indexOf(category);
        if (categoryIndex !== -1) {
          this.selectedCategories.splice(categoryIndex, 1);
        }

        if (category.categories && category.categories.length) {
          this.deselectChildren(category.categories);
        }
      }
    },

    onCategorySelected(payload) {
      if (this.singleSelect) {
        const selectedCategories = payload.parent ? [payload.parent, payload.item] : [payload.item];
        this.selectedCategories = selectedCategories;
      } else {
        const { item, selected } = payload;
        const filteredItems = this.selectedCategories.filter(selectedCategory => selectedCategory.id === item.id || selectedCategory.id === item.category_id);
        if (filteredItems.length) {
          filteredItems.forEach((filteredItem) => {
            const itemIndex = this.selectedCategories.indexOf(filteredItem);
            this.selectedCategories.splice(itemIndex, 1);
          });
        }

        if (!selected && item.categories && item.categories.length) {
          this.deselectChildren(item.categories);
        }

        const categoryIndex = this.selectedCategories.indexOf(item);
        if (selected && categoryIndex === -1) {
          this.selectedCategories.push(item);
        }
      }

      this.$emit('category-selector:selected', this.selectedCategories);
    },
  },

  computed: {
    getCategories() {
      if (this.availableCategories.length) {
        return this.availableCategories;
      }

      return this.categories;
    },
  },
};
</script>
